export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const title = node.data.title || ''
  const postbackId = node.data.postbackId || ''

  let html = `<p class="card-text"><strong>Title</strong>: ${title}</p>`
  html += '<p class="card-text"><strong>Postback ID</strong>: ' + postbackId + '</p>'

  if (! title && ! postbackId) {
    $('#hover-node-card .card-body').html('')
  } else {
    $('#hover-node-card .card-body').html(html)
  }
}